<app-header></app-header>
<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>
<div class="container" style="width:100%; margin-top:30px">
	<div class="row" style="margin-top:5px;margin-bottom:5px">

					<div class="col-sm-12 col-xs-12 col-md-4 col-lg-3 col-xl-3   pull-left" >
							<div id="tg-content" class="tg-content tg-dashboard" >
						<div class="tg-widgetdashboard"  >
							<div class="tg-widgetprofile">
								<figure class="tg-directpostimg"> <a><img src="https://passport.petcart.in/images/userimgs/{{sphoto}}"

									alt="image description" ></a>
								</figure>
								<div class="tg-directposthead">
										<div class="row " >
												<div class="col-12 text-center">
														<input type="file" style="text-align:center" ngFileSelect [options]='options' (onUpload)="handleUpload($event)" (beforeUpload)="beforeUpload($event)">
												</div>
												
											</div>
									<h3>{{spname}}</h3>
									<div class="tg-subjects" style="overflow-wrap:break-word">{{spqua}}</div>
								</div>
								<a class="btn btn-success" routerLink="/doctor/profilemanage">Edit Profile</a> </div>
							<nav id="tg-dashboardnav" class="tg-dashboardnav">
								<ul style="list-style:none;color:#000; cursor: pointer;" >
									<li class="tg-successmessage"> <a routerLink="/doctor/appointment"> <i class="fa fa-clipboard" aria-hidden="true"></i> <span>My Appointments</span> </a> </li>
									<li class="tg-successmessage" *ngIf="sprovider"> <a routerLink="/doctor/appointmentscreen/{{sprovider[0].id}}"> <i class="fa fa-clipboard" aria-hidden="true"></i> <span> Appointment Screen</span> </a> </li>
									<li class="tg-errormessage"> <a routerLink="/doctor/manageschedule"> <i class="fa fa-calendar" aria-hidden="true"></i> <span>Manage Calendar</span> </a> </li>
									<li> <a routerLink="/doctor/manageexistingpatient"> <i class="fa fa-user-circle" aria-hidden="true"></i> <span>Manage Customers</span> </a> </li>
									<li> <a routerLink="/chats"> <i class="fa fa-comments" aria-hidden="true"></i> <span>Manage Chat</span> </a> </li>

									<!--<li> <a routerLink="/forum/home"> <i class="fa fa-eye"></i> <span>Answer Queries</span> </a> </li>-->
									<li *ngIf="onlineflag === 1" (click)="goOffline()"><a  class="skel-layers-ignoreHref"  style="cursor: pointer"><i class="fa fa-times-circle" aria-hidden="true"></i> <span>Go Offline</span></a></li>
									<li *ngIf="onlineflag === 0" (click)="goOnline()"><a  class="skel-layers-ignoreHref" style="cursor: pointer"><i class="fa fa-check" aria-hidden="true"></i> <span>Go Online</span></a></li>

									<li (click)="logOut()"> <a ><i class="fa fa-server" aria-hidden="true"></i> <span>Logout</span> </a> </li>
								</ul>
							</nav>
						</div>
					</div>
				</div>
					<div class="col-lg-9 col-md-8 col-sm-8 col-xs-12 pull-right">
						<div class="tg-dashboardtabs">
							<router-outlet></router-outlet>
							</div>
							</div>


	</div>
</div>







<div class="footer">
	<app-footer></app-footer>
</div>
